module.exports = __webpack_public_path__ + "static/img/MainScreen.7fc4328.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Instruction/MainScreen.jpeg
// module id = 1744
// module chunks = 36 37